import { AccountType } from '../../core'

export const INCOME_ACCOUNT_TYPES = [
  AccountType.ANY,
  AccountType.CASH,
  AccountType.CHECKING,
  AccountType.DIGITAL_WALLET,
  AccountType.PREPAID,
  AccountType.SAVINGS,
]

export const PAYMENT_ACCOUNT_TYPES = [
  AccountType.CHECKING_LINE_OF_CREDIT,
  AccountType.CREDIT_CARD,
  AccountType.LINE_OF_CREDIT,
  AccountType.LOAN,
  AccountType.MORTGAGE,
]

export const SPENDING_ACCOUNT_TYPES = [
  AccountType.ANY,
  AccountType.CASH,
  AccountType.CHECKING,
  AccountType.CHECKING_LINE_OF_CREDIT,
  AccountType.CREDIT_CARD,
  AccountType.DIGITAL_WALLET,
  AccountType.LINE_OF_CREDIT,
  AccountType.PREPAID,
  AccountType.SAVINGS,
]
